/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Full_Art_NoteInputs */

const en_services_svc_full_art_note = /** @type {(inputs: Services_Svc_Full_Art_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illustrative monitor, drawn from the systems we run.`)
};

const lv_services_svc_full_art_note = /** @type {(inputs: Services_Svc_Full_Art_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilustratīvs piemērs no mūsu darbinātajām sistēmām.`)
};

/**
* | output |
* | --- |
* | "Illustrative monitor, drawn from the systems we run." |
*
* @param {Services_Svc_Full_Art_NoteInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_full_art_note = /** @type {((inputs?: Services_Svc_Full_Art_NoteInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Full_Art_NoteInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_full_art_note(inputs)
	return en_services_svc_full_art_note(inputs)
});